import {
  cta_linkTextAlert,
  text_colorTextPrimary,
  text_colorTextSecondary,
  text_colorTextSuccess,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_family_weight_regular,
  font_md,
  font_sm,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  & .wrapper {
    display: flex;
    align-items: center;
    gap: ${spacing(2)};

    overflow: hidden;
    font-family: ${font_family_weight_regular};
  }

  & .text-container {
    max-width: 100%;
    display: flex;
    flex-direction: column;
    gap: ${spacing(1)};
    overflow: hidden;

    &.bold {
      font-family: ${font_family_weight_medium};
    }

    &.alignRight {
      text-align: end;
    }

    .text {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      ${font_md};
      color: ${text_colorTextPrimary};

      &.highlight {
        color: ${text_colorTextSuccess};
      }
      &.severe {
        color: ${cta_linkTextAlert};
      }
    }

    .subtext {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      ${font_sm};
      color: ${text_colorTextSecondary};

      &.highlight {
        color: ${text_colorTextSuccess};
      }
      &.severe {
        color: ${cta_linkTextAlert};
      }
    }
  }
`
